import { writable, readable } from 'svelte/store';
import pref from './prefs/24-mie.js';

export const ie11 = pref.ie11;
export const ie11Recommendation = readable(pref.ie11Recommendation);
export const pcd = readable(pref.pcd);
export const pname = readable(pref.pname);
export const header = readable(pref.header);
export const explanation = readable(pref.explanation ? pref.explanation : "本サイトは、GoToEat食事券の申込受付サイトです。\nGoToEat食事券の申込方法をご案内しますので、以下に同意したうえでメールアドレスのご登録をお願いいたします。");
export const personalinfo = readable(pref.personalinfo ? pref.personalinfo : "ご入力いただきました個人情報は、GoToEat食事券の販売のために使用いたします。\n個人情報は、法令に基づく場合を除き、ご本人様の承諾なしに第三者（弊社業務委託先を除く）に提供することはありません。");
export const privacy = readable(pref.privacy);
export const terms = readable(pref.terms);
export const startdatenotice = readable(Object.assign({
    header:"◆GoToEat　食事券の引き取り開始日時についての注意事項◆",
    alert: "",
    body: "GoToEat 食事券の申込みを頂きありがとうございます。\n\nご登録頂きました、メールアドレス宛に配信されます【GoToEat食事券】申込完了通知の内容をご確認の上、お近くのファミリーマートにてお支払い、食事券のお受取りをお願いいたします。",
    danger: "お引き取り開始につきましては、お申込み日の翌々日" + pref.starttime + "からとなりますのでご注意ください。",
    help: "申込完了通知に記載されている入金発券期間を必ずご確認の上、入金発券のお手続きをお願いいたします。",
    footer: "★ファミリーマートでの食事券のお引換えの際のお願い★\n昼（11:30～13:30頃）、及び夜（17:00～20:00頃）につきましては、店舗が混雑する時間帯のため、食事券の発券に時間を要することが想定されます。こちらの時間帯を避けてご来店いただけますようご協力をお願い致します。"
}, pref.startdatenotice ? pref.startdatenotice : {}));
export const completemsg = readable(pref.completemsg ? pref.completemsg : {
    header: "食事券のお申込み｜申込完了",
    body: {
        lines: [
            "お申込みを受付しました。",
            "ご登録されたメールアドレスに、申込完了通知を送信しました。",
            "食事券のお受け取りには、メールに記載の引換票番号が必要になります。\nメールに記載の入金発券期間にて、ファミリーマートでお支払い、食事券のお受け取りをお願いします。",
            "いかなる場合でも、メールの再送、引換票番号の再発行はできません。大切に保存ください。\n※メールを削除または紛失した場合は、再度受付サイトにてメールアドレスの登録から、手続きを行ってください。"
        ]
    }
});
export const cid = readable(pref.cid);
export const unitdetails = readable(pref.unitdetails);
export const ticketvalue = readable(pref.ticketvalue);
export const unitprice = readable(pref.unitprice);
export const maxunits = readable(pref.maxunits);
export const quantityoptions = readable(pref.quantityoptions);
export const starttime = readable(pref.starttime);
export const api = readable(pref.api ? pref.api : 'https://rest.funity-rs.jp');
export const msg = writable('');
export const msghistory = writable([]);
export const messages = readable({
    busy: "ただいまアクセスの集中により、サービスをご利用いただくことができません。\n大変申し訳ございませんが、しばらくお時間を開けて、再度ご利用いただけますようお願いいたします。\nご不便をおかけいたしますが、ご理解のほど宜しくお願いいたします。",
    error: "ただいまアクセスの集中により、サービスをご利用いただくことができません。\n大変申し訳ございませんが、しばらくお時間を開けて、再度ご利用いただけますようお願いいたします。\nご不便をおかけいたしますが、ご理解のほど宜しくお願いいたします。"
});
export const entry = writable({
    onsale: null,
    salestitle: "",
    salesterm: "",
    email: "",
    termsagree: false,
    privacyagree: false,
    complete: false
});
export const apply = writable({
    t: null,
    email: " ",
    lastname: null,
    firstname: null,
    lastnamekana: null,
    firstnamekana: null,
    zipcode: null,
    prefecture: null,
    city: null,
    tel: null,
    age: null,
    gender: null,
    quantity: null,
    onsale: null,
    salestitle: "-",
    salesterm: "-",
    complete: false
});